import { render, staticRenderFns } from "./DuplicateIDCardNumber.vue?vue&type=template&id=bda685e8&"
import script from "./DuplicateIDCardNumber.vue?vue&type=script&lang=js&"
export * from "./DuplicateIDCardNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports